export default __webpack_public_path__ + "static/media/arenfil.692a7fee.svg";